import axios from ".";

export const facebookLogin = () => {
  return axios({
    method: "GET",
    url: "/facebook-login",
  });
};

export const facebookUserTokenStatus = () => {
  return axios({
    method: "GET",
    url: "/facebook/user-token-status",
  });
};
